import Button from "components/Buttons/ThemeButton";
import { useDIPAction } from "components/DIP/hooks";
import { useGoogleAnalyticsContext } from "contexts/GoogleAnalyticsProvider";
import { useAppSelector } from "hooks";
import { Fragment } from "react";
import { selectDipState } from "redux/slices";
import { getButtonLabel } from "./helper";
import { buttonStyled, InformativeStyled } from "./styles";
import { useLocation } from "react-router-dom";
import { DipButton } from "interfaces";

interface InformativeProps {}

export const Informative: React.FC<InformativeProps> = () => {
	const location = useLocation();
	const { onAction } = useDIPAction();
	const { currentDip } = useAppSelector(selectDipState);
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();

	if (!currentDip) {
		return <Fragment />;
	}
	const { buttons } = currentDip;

	const handleButtonClick = (button: DipButton) => {
		onAction(button);
		reportEvent("continue_shopping_click", {
			source: "dips_dialog",
			page_location: location.pathname
		});
		reportPlaygamiEvent("tp.web_frontend", {
			event_name: "continue_shopping_click",
			event_type: "continue_shopping_click",
			action: "click",
			source: "dips_dialog",
			page_location: location.pathname
		});
	};

	return (
		<InformativeStyled>
			{buttons?.map((button) => (
				<Button
					key={button.id}
					style={{ zIndex: 90 }}
					sx={buttonStyled}
					themeColor={
						button.actionType === "customerSupport" ? "secondary" : "primary"
					}
					onClick={() => handleButtonClick(button)}
				>
					{getButtonLabel(button)}
				</Button>
			))}
		</InformativeStyled>
	);
};
